import React, { useEffect, useState } from "react";
import { Pause, Play } from "lucide-react";

const partners = "100+ Fin Tech companies, NBFCs, Finance Banks, Private financiers, Investors";
const items = ["100+ Fin Tech companies", "NBFCs", "Finance Banks", "Private financiers", "Investors"];

export const PartnerTicker = () => {
  const [strip, setStrip] = useState(null);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    let cancelled = false;
    // One exact-width repeat tile keeps the wrap seamless at any viewport width.
    // The accessible, non-animated partner text is retained below.
    document.fonts.ready.then(() => {
      if (cancelled) return;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      const font = '600 17px "IBM Plex Sans", sans-serif';
      ctx.font = font;
      const widths = items.map((item) => ctx.measureText(item).width);
      const width = Math.ceil(widths.reduce((total, size) => total + size + 72, 0));
      const scale = Math.min(window.devicePixelRatio || 1, 3);
      canvas.width = Math.ceil(width * scale);
      canvas.height = Math.ceil(28 * scale);
      ctx.scale(scale, scale);
      ctx.font = font;
      ctx.textBaseline = "middle";
      let x = 0;
      items.forEach((item, index) => {
        ctx.fillStyle = "#0a2540";
        ctx.fillText(item, x, 14);
        ctx.fillStyle = "#c72c37";
        ctx.fillText("✦", x + widths[index] + 28, 14);
        x += widths[index] + 72;
      });
      setStrip({ image: canvas.toDataURL(), width });
    });
    return () => { cancelled = true; };
  }, []);
  return (
    <section className="partner-ticker" data-testid="partner-ticker" aria-label="Our partner network">
      <div className="container-x ticker-inner">
        <span className="ticker-label">OUR NETWORK</span>
        <div className="ticker-window" data-testid="partner-ticker-window">
          <span className="sr-only" data-testid="partner-network-text">{partners}</span>
          <div className="ticker-text" style={{
            animationPlayState: paused ? "paused" : "running",
            animationName: strip ? "partner-flow" : "none",
            animationDuration: strip ? `${strip.width / 45}s` : undefined,
            backgroundImage: strip ? `url(${strip.image})` : undefined,
            backgroundSize: strip ? `${strip.width}px 28px` : undefined,
            "--ticker-distance": strip ? `${strip.width}px` : undefined,
          }} aria-hidden="true" data-testid="partner-ticker-track">{strip ? null : partners}</div>
          <span className="ticker-static" aria-hidden="true">{partners}</span>
        </div>
        <button type="button" onClick={() => setPaused(!paused)} aria-label={paused ? "Play partner ticker" : "Pause partner ticker"} aria-pressed={paused} title={paused ? "Play partner ticker" : "Pause partner ticker"} className="ticker-control" data-testid="partner-ticker-toggle">
          {paused ? <Play size={15} /> : <Pause size={15} />}
        </button>
      </div>
    </section>
  );
};